// 選択肢からラベルを取得する関数
export const getLabel = (choices: string[][], value: string): string => {
    const choice = choices.find(([choiceValue]) => choiceValue === value);
    return choice ? choice[1] : value;
};

export const getWindowText = (
    lowerChoices: string[][],
    upperChoices: string[][],
    targetLowerValue?: string | null,
    targetUpperValue?: string | null,
): string | null => {
    if (!targetLowerValue && !targetUpperValue) {
        return null;
    }

    if (targetLowerValue && targetUpperValue) {
        return `${getLabel(lowerChoices, targetLowerValue)}〜${getLabel(upperChoices, targetUpperValue)}`;
    } else if (targetLowerValue) {
        return `${getLabel(lowerChoices, targetLowerValue)}〜上限なし`;
    } else if (targetUpperValue) {
        return `下限なし〜${getLabel(upperChoices, targetUpperValue)}`;
    }
    return '指定なし';
};
